import React from 'react';
import Slider from 'react-slick';
import UnbxdProductCardlike from '../../UnbxdProductCardlike';

function YouMayAlsoLike(props) {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,  // Default number of slides to show (on large screens)
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,  // Screen width of 1024px or less
        settings: {
          slidesToShow: 3,  // Show 3 slides on medium-sized screens
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,  // Screen width of 768px or less (tablets)
        settings: {
          slidesToShow: 1,  // Show 2 slides on tablet-sized screens
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,  // Screen width of 480px or less (mobile)
        settings: {
          slidesToShow: 1,  // Show 2 slides on mobile phones
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <Slider {...settings}>
      {props.products.map((prod, index) => (
        <UnbxdProductCardlike key={index} product={prod} UnbxdRecomendatoRequestID={props.UnbxdRecomendatoRequestID} widget={props.widget} prank={index + 1}/>
      ))}
    </Slider>
  );
}

export default YouMayAlsoLike;
